import React, { useEffect, useState } from 'react';

import { PaymentType } from 'services/payment.service.ts';
import { useAppDispatch, useAppSelector } from 'store/store-hooks.ts';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';
import { buyFc, upgradeResolution } from './_payment.slice';

import { Modal } from 'components/UI/modal/modal.tsx';
import { Select } from 'components/UI/select/select.tsx';
import { AppButton } from 'components/app/app-components/app-button/app-button';
import { fcStripePlans, fetchFinalCut } from 'components/app/finalcuts/_mediator/fc-data.slice';
import { PaymentLoader } from './_payment-loader';
import styles from './_payment.module.scss';

export const PaymentFcModal = () => {
  const modal = useAppSelector((state) => state.app.modal);
  const dispatch = useAppDispatch();
  return (
    <Modal
      isOpen={modal === ModalEnum.fcUpgrade}
      onRequestClose={() => dispatch(setModal(0))}
      className={styles.PaymentFc}
    >
      <__Inner />
    </Modal>
  );
};

/* C O M P O N E N T S */

const __Inner = () => {
  const finalCutId = useAppSelector((state) => state.fc__data.id);
  const stripePlans = useAppSelector(fcStripePlans);
  const dispatch = useAppDispatch();

  const [loader, setLoader] = useState(false);
  const [paymentPlan, setPaymentPlan] = useState<PaymentType>();

  const handlePlanChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPaymentPlan(+e.target.value);
  };

  const handleBuy = () => {
    if (!finalCutId || !paymentPlan) return;
    setLoader(true);
    const plan = stripePlans.find((p) => p.value === paymentPlan);
    if (plan?.price === 0) {
      dispatch(upgradeResolution({ finalCutId, paymentPlan })).finally(() => {
        setLoader(false);
        dispatch(fetchFinalCut(finalCutId));
        dispatch(setModal(0));
      });
    } else {
      dispatch(buyFc({ finalCutId, paymentPlan })).finally(() => setLoader(false));
    }
  };

  useEffect(() => {
    setPaymentPlan(stripePlans[0].value);
  }, []);

  return (
    <>
      <h3>Choose Upgrade Settings</h3>
      <Select
        className={styles.PaymentFc__select}
        options={stripePlans}
        value={paymentPlan}
        placeholder="Choose a plan"
        onChange={handlePlanChange}
        colored
      />
      <AppButton onClick={handleBuy}>Upgrade</AppButton>
      <PaymentLoader showLoader={loader} />
    </>
  );
};
